@if (isMobile$ | async) {
  <app-mobile-layout></app-mobile-layout>
} @else {
  <app-desktop-layout></app-desktop-layout>
}
